import { Link } from 'react-router-dom';

const heroImage = 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%20of%20a%20modern%20digital%20news%20media%20office%20with%20dramatic%20red%20accent%20lighting%2C%20professional%20broadcast%20studio%20atmosphere%2C%20multiple%20monitors%20displaying%20entertainment%20news%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20film%20grain%20texture%2C%20sophisticated%20media%20headquarters%20aesthetic%2C%20dark%20moody%20background%20with%20subtle%20red%20glow&width=1920&height=600&seq=about-hero-01&orientation=landscape';

export default function AboutHero() {
  return (
    <section className="relative w-full h-[380px] md:h-[480px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="51吃瓜官网 - 关于我们"
          title="51吃瓜官网 - 全网独家吃瓜爆料入口"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center z-10">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 mb-4 bg-primary-500/90 text-background-50 text-xs font-label font-semibold rounded-full">
          <i className="ri-information-line"></i>
          关于我们
        </span>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-3 max-w-3xl">
          全网独家吃瓜爆料入口
        </h1>
        <p className="text-sm md:text-base text-background-50/70 max-w-xl leading-relaxed">
          我们致力于为广大吃瓜群众提供最新、最全、最真实的娱乐八卦资讯。吃瓜无罪，八卦有理。
        </p>
      </div>
    </section>
  );
}